import { Box, styled } from '@mui/material';

import { SIZES } from '../../assets/constants/constants.ts';
import { Breadcrumbs, type BreadcrumbItem } from '../Breadcrumbs/index.ts';
import Section from '../Section/index.ts';

const Container = styled('div')({
  maxWidth: SIZES.layout.width.sm,
  width: '100%',
});

const Content = styled('div')(({ theme }) => ({
  '& p, li': {
    fontSize: '1.125rem',
    lineHeight: 1.4,
    marginBottom: theme.spacing(1),
  },
  '& a': {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  '& h2': {
    ...theme.typography.h2,
  },
  '& h3': {
    fontSize: '1.25rem',
    [theme.breakpoints.up('sm')]: {
      ...theme.typography.h3,
    },
  },
  '& h4': {
    ...theme.typography.subtitle1,
  },
  '& .contact': {
    marginTop: theme.spacing(6),
    '& p': {
      fontSize: '1.375rem',
      fontWeight: theme.typography.fontWeightBold,
      margin: 0,
    },
  },
}));

export type StaticPageLayoutProps = {
  title?: string;
  subtitle?: string;
  breadcrumbsItems?: BreadcrumbItem[];
  children?: React.ReactNode;
} & React.ComponentProps<typeof Section>;

const StaticPageLayout: React.FC<StaticPageLayoutProps> = ({
  title = '',
  subtitle = '',
  breadcrumbsItems = [],
  children = null,
  ...props
}) => {
  return (
    <Section last overflow="visible" {...props}>
      <Container>
        {breadcrumbsItems.length > 0 ? (
          <Box
            sx={{
              mb: { xs: 3, sm: 8 },
            }}
          >
            <Breadcrumbs items={breadcrumbsItems} />
          </Box>
        ) : null}

        {title !== '' || subtitle !== '' ? (
          <Box
            sx={{
              mb: { xs: 3, sm: 6 },
            }}
          >
            {title ? (
              <h1 className="typography-v1-legacy-h1 text-v1-background-200">{title}</h1>
            ) : null}
            {subtitle ? (
              <h2 className="typography-v1-legacy-subtitle1 text-v1-primary-100">{subtitle}</h2>
            ) : null}
          </Box>
        ) : null}

        {children ? <Content>{children}</Content> : null}
      </Container>
    </Section>
  );
};

export default StaticPageLayout;
